module.exports = __webpack_public_path__ + "static/media/sort_down.797644d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sort_down.svg
// module id = 569
// module chunks = 0